// TestimonialsPage.jsx

import React from "react";
import { Box, Typography, Grid, Card, CardContent, Avatar } from "@mui/material";
import testimonialsData from "../../data/testimonialData.json"; 
import TestimonialsPageStyles from "./TestimonialsPage.styles"; 

const TestimonialsPage = () => {
  return (
    <Box sx={TestimonialsPageStyles.pageContainer}>
      <Typography variant="h4" sx={TestimonialsPageStyles.pageTitle}>
        What Our Clients Say
      </Typography>
      <Typography variant="body1" sx={TestimonialsPageStyles.pageSubtitle}>
        See how we've helped clients find their dream homes.
      </Typography>

      <Grid container spacing={4} sx={TestimonialsPageStyles.cardContainer}>
        {testimonialsData.map((testimonial, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={TestimonialsPageStyles.card}>
              <CardContent>
                <Box sx={TestimonialsPageStyles.avatarContainer}>
                  <Avatar src={testimonial.image} alt={testimonial.name} sx={TestimonialsPageStyles.avatar} />
                </Box>
                <Typography variant="body2" sx={TestimonialsPageStyles.testimonialText}>
                  "{testimonial.text}"
                </Typography>
                <Typography variant="h6" sx={TestimonialsPageStyles.clientName}>
                  - {testimonial.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TestimonialsPage;